import { IVerifyPromoCodeResponse, IVerifyPromoInput } from "./promo-code.interface";

import VERIFY_PROMO_CODE from "./promo-code.query";
import { useLazyQuery } from "@apollo/client";

export const useVerifyPromoCode = () => {
  const [verifyPromoCode, { loading, data, error }] = useLazyQuery<{ verifyPromoCode: IVerifyPromoCodeResponse }>(
    VERIFY_PROMO_CODE,
  );

  const getVerifyPromoCode = (verifyPromoInput: IVerifyPromoInput) => {
    verifyPromoCode({
      variables: { verifyPromoInput },
      fetchPolicy: "no-cache",
    });
  };

  return { getVerifyPromoCode,
    loading,
    promoCodeResponse: data?.verifyPromoCode,
    error };
};
